module.exports = __webpack_public_path__ + "static/media/empty_cars.0033ae83.svg";